import type { FormSchema } from '@cli-types/core-engine/schema.js'
import { FORM_SUBMISSION_COLUMN_NAMES } from '@cli-constants/schema.js'
import { getAllFormSchemaFields } from '@core-engine/schema/field-helpers/form-fields/get-all-form-schema-fields.js'

export function collectInvalidFormColumnReferenceErrors(
  schema: FormSchema,
  errors: string[]
): void {
  const fieldNames = new Set(
    getAllFormSchemaFields(schema)
      .map((field) => field.name)
      .filter((name): name is string => typeof name === 'string' && name.length > 0)
  )

  for (const columnName of FORM_SUBMISSION_COLUMN_NAMES) {
    fieldNames.add(columnName)
  }

  for (const column of schema.columns || []) {
    if (!column.accessorKey || !column.header) {
      errors.push(`Form column is missing required properties: ${JSON.stringify(column)}`)
    } else if (!fieldNames.has(column.accessorKey)) {
      errors.push(
        `Form column accessorKey "${column.accessorKey}" does not match any field or generated submission property. Available: ${Array.from(fieldNames).join(', ')}`
      )
    }
  }
}
